import Vue from 'vue';
import Vuex from 'vuex';

import accounts from './modules/accounts';
import agentBots from './modules/agentBots';
import agents from './modules/agents';
import aiAssist from './modules/aiAssist';
import articles from './modules/helpCenterArticles';
import attributes from './modules/attributes';
import auth from './modules/auth';
import auditlogs from './modules/auditlogs';
import auditEvents from './modules/auditEvents';
import automations from './modules/automations';
import bulkActions from './modules/bulkActions';
import campaigns from './modules/campaigns';
import cannedResponse from './modules/cannedResponse';
import categories from './modules/helpCenterCategories';
import contactConversations from './modules/contactConversations';
import contactLabels from './modules/contactLabels';
import contactNotes from './modules/contactNotes';
import contactPreChatData from './modules/contactPreChatData';
import contacts from './modules/contacts';
import conversationLabels from './modules/conversationLabels';
import conversationMetadata from './modules/conversationMetadata';
import conversationPage from './modules/conversationPage';
import conversations from './modules/conversations';
import conversationSearch from './modules/conversationSearch';
import conversationStats from './modules/conversationStats';
import conversationTypingStatus from './modules/conversationTypingStatus';
import conversationWatchers from './modules/conversationWatchers';
import csat from './modules/csat';
import customViews from './modules/customViews';
import dashboardApps from './modules/dashboardApps';
import globalConfig from 'shared/store/globalConfig';
import inboxAssignableAgents from './modules/inboxAssignableAgents';
import inboxes from './modules/inboxes';
import inboxMembers from './modules/inboxMembers';
import integrations from './modules/integrations';
import labels from './modules/labels';
import macros from './modules/macros';
import mantap from './modules/mantap';
import notifications from './modules/notifications';
import portals from './modules/helpCenterPortals';
import reports from './modules/reports';
import sla from './modules/sla';
import teamMembers from './modules/teamMembers';
import teams from './modules/teams';
import userNotificationSettings from './modules/userNotificationSettings';
import webhooks from './modules/webhooks';
import mcpKeys from './modules/mcpKeys';
import draftMessages from './modules/draftMessages';
import SLAReports from './modules/SLAReports';
import scheduledMessage from './modules/scheduledMessage';
import knowledge from './modules/knowledge';
import stripe from './modules/stripe';
import creditUsage from './modules/creditUsage';
import appointments from './modules/appointments';
import dify from './modules/dify';
import whatsapp from './modules/whatsapp';
import whatsappCampaigns from './modules/whatsappCampaigns';
import chatbotConfig from './modules/chatbotConfig';
import rentalBranch from './modules/rentalBranch';
import whitelist from './modules/whitelist';
import condoMngt from './modules/condoMngt';
import realEstate from './modules/realEstate';
import realEstateAgents from './modules/realEstateAgents';
import realEstateAppointments from './modules/realEstateAppointments';
import realEstateCalendar from './modules/realEstateCalendar';
import coLivingConfig from './modules/coLivingConfig';
import coLivingCatalog from './modules/coLivingCatalog';
import coLivingCondos from './modules/coLivingCondos';
import coLivingTeam from './modules/coLivingTeam';
import coLivingResidents from './modules/coLivingResidents';
import coLivingTickets from './modules/coLivingTickets';
import coLivingRouting from './modules/coLivingRouting';
import gsheet from './modules/gsheet';
import jmb from './modules/jmb';
import branch from './modules/branch';
import serviceV2 from './modules/serviceV2';
import staffV2 from './modules/staffV2';
import branchV2 from './modules/branchV2';
import branchServices from './modules/branchServices';
import override from './modules/override';
import schedules from './modules/schedules';
import vouchers from './modules/vouchers';
import conditions from './modules/conditions';
import branchStaff from './modules/branchStaff';
import adsConfig from './modules/adsConfig';
import adsAnalytics from './modules/adsAnalytics';
import adsAnalyticsPanel from './modules/adsAnalyticsPanel';
import customAnalytics from './modules/customAnalytics';
import appointmentsV2 from './modules/appointmentsV2';
import serviceOptions from './modules/serviceOptions';
import staffOptions from './modules/staffOptions';
import branchOptions from './modules/branchOptions';
import serviceStaff from './modules/serviceStaff';
import appointmentsV3 from './modules/appointmentsV3';
import assignments from './modules/assignments';
import promotions from './modules/promotions';
import onboarding from './modules/onboarding';
import onboardingKnowledge from './modules/onboardingKnowledge';
import onboardingGuide from './modules/onboardingGuide';
import sandbox from './modules/sandbox';
import operatingHours from './modules/operatingHours';
import staffCalendar from './modules/staffCalendar';
import aoikumo from './modules/aoikumo';
import aoikumoRooms from './modules/aoikumoRooms';

const plugins = [];

Vue.use(Vuex);

// Build modules object conditionally
const buildModules = () => {
  const modules = {
    accounts,
    agentBots,
    agents,
    aiAssist,
    articles,
    attributes,
    auth,
    automations,
    auditlogs,
    auditEvents,
    bulkActions,
    campaigns,
    cannedResponse,
    categories,
    contactConversations,
    contactLabels,
    contactNotes,
    contactPreChatData,
    contacts,
    conversationLabels,
    conversationMetadata,
    conversationPage,
    conversations,
    conversationSearch,
    conversationStats,
    conversationTypingStatus,
    conversationWatchers,
    csat,
    customViews,
    dashboardApps,
    globalConfig,
    inboxAssignableAgents,
    inboxes,
    inboxMembers,
    integrations,
    labels,
    macros,
    mantap,
    notifications,
    portals,
    reports,
    teamMembers,
    teams,
    userNotificationSettings,
    webhooks,
    mcpKeys,
    draftMessages,
    sla,
    slaReports: SLAReports,
    knowledge,
    stripe,
    creditUsage,
    appointments,
    scheduledMessage,
    dify,
    whatsapp,
    whatsappCampaigns,
    chatbotConfig,
    rentalBranch,
    whitelist,
    condoMngt,
    realEstate,
    realEstateAgents,
    realEstateAppointments,
    realEstateCalendar,
    coLivingConfig,
    coLivingCatalog,
    coLivingCondos,
    coLivingTeam,
    coLivingResidents,
    coLivingTickets,
    coLivingRouting,
    gsheet,
    jmb,
    branch,
    serviceV2,
    staffV2,
    branchV2,
    branchServices,
    override,
    schedules,
    vouchers,
    conditions,
    branchStaff,
    adsConfig,
    adsAnalytics,
    adsAnalyticsPanel,
    customAnalytics,
    appointmentsV2,
    serviceOptions,
    staffOptions,
    branchOptions,
    serviceStaff,
    appointmentsV3,
    assignments,
    promotions,
    onboarding,
    onboardingKnowledge,
    onboardingGuide,
    sandbox,
    operatingHours,
    staffCalendar,
    aoikumo,
    aoikumoRooms,
  };

  return modules;
};

export default new Vuex.Store({
  modules: buildModules(),
  plugins,
});
